<script setup>
import DashboardTable from '@frontJs/components/tables/DashboardTable.vue';
import ProjectionTable from '@frontJs/components/tables/ProjectionTable.vue';
import { useUser } from '@frontJs/composables/user';
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import { hasRole } from '@js/utils/permission';
import { h } from 'vue';

const { currentUserEmail } = useUser();

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title>Tableau de bord - Datakepler</title>
    </Head>

    <TabLayout
        v-if="hasRole('super_admin')"
        :tabs="{
            dashboard: {
                title: 'Tableau de bord',
                items: {
                    eCommerce: {
                        title: 'E-commerce',
                        content: h(DashboardTable, { type: 'e-commerce' }),
                    },
                    showcase: {
                        title: 'Vitrine',
                        content: h(DashboardTable, { type: 'showcase' }),
                    },
                    ...(currentUserEmail === 'anthony@apikom.fr' ||
                    currentUserEmail === 'valere@apikom.fr' ||
                    currentUserEmail === 'sophie@apikom.fr' ||
                    currentUserEmail === 'theo@apikom.fr' ||
                    currentUserEmail === 'nicolas@apikom.fr' ||
                    currentUserEmail === 'benoit@apikom.fr'
                        ? {
                              apikom: {
                                  title: 'Apikom',
                                  content: h(DashboardTable, { apikom: true }),
                              },
                          }
                        : {}),
                    marketplace: {
                        title: 'Marketplace',
                        content: h(DashboardTable, { type: 'marketplace' }),
                    },
                    shop: {
                        title: 'Boutique',
                        content: h(DashboardTable, { type: 'shop' }),
                    },
                    customMade: {
                        title: 'Sur-mesure',
                        content: h(DashboardTable, { type: 'custom-made' }),
                    },
                    other: {
                        title: 'Autre',
                        content: h(DashboardTable, { type: 'other' }),
                    },
                },
            },
            projectionD7: {
                title: 'Projection J7',
                items: {
                    eCommerce: {
                        title: 'E-commerce',
                        content: h(ProjectionTable, {
                            type: 'e-commerce',
                            days: 7,
                        }),
                    },
                    showcase: {
                        title: 'Vitrine',
                        content: h(ProjectionTable, {
                            type: 'showcase',
                            days: 7,
                        }),
                    },
                    ...(currentUserEmail === 'anthony@apikom.fr' ||
                    currentUserEmail === 'valere@apikom.fr' ||
                    currentUserEmail === 'sophie@apikom.fr' ||
                    currentUserEmail === 'theo@apikom.fr' ||
                    currentUserEmail === 'nicolas@apikom.fr' ||
                    currentUserEmail === 'benoit@apikom.fr'
                        ? {
                              apikom: {
                                  title: 'Apikom',
                                  content: h(ProjectionTable, {
                                      apikom: true,
                                      days: 7,
                                  }),
                              },
                          }
                        : {}),
                    marketplace: {
                        title: 'Marketplace',
                        content: h(ProjectionTable, {
                            type: 'marketplace',
                            days: 7,
                        }),
                    },
                    shop: {
                        title: 'Boutique',
                        content: h(ProjectionTable, { type: 'shop', days: 7 }),
                    },
                },
            },
            projectionD30: {
                title: 'Projection J30',
                items: {
                    eCommerce: {
                        title: 'E-commerce',
                        content: h(ProjectionTable, {
                            type: 'e-commerce',
                            days: 30,
                        }),
                    },
                    showcase: {
                        title: 'Vitrine',
                        content: h(ProjectionTable, {
                            type: 'showcase',
                            days: 30,
                        }),
                    },
                    ...(currentUserEmail === 'anthony@apikom.fr' ||
                    currentUserEmail === 'valere@apikom.fr' ||
                    currentUserEmail === 'sophie@apikom.fr' ||
                    currentUserEmail === 'theo@apikom.fr' ||
                    currentUserEmail === 'nicolas@apikom.fr' ||
                    currentUserEmail === 'benoit@apikom.fr'
                        ? {
                              apikom: {
                                  title: 'Apikom',
                                  content: h(ProjectionTable, {
                                      apikom: true,
                                      days: 30,
                                  }),
                              },
                          }
                        : {}),
                    marketplace: {
                        title: 'Marketplace',
                        content: h(ProjectionTable, {
                            type: 'marketplace',
                            days: 30,
                        }),
                    },
                    shop: {
                        title: 'Boutique',
                        content: h(ProjectionTable, { type: 'shop', days: 30 }),
                    },
                },
            },
        }"
    />

    <TabLayout
        v-else
        :tabs="{
            dashboard: {
                title: 'Tableau de bord',
                content: h(DashboardTable),
            },
            projectionD7: {
                title: 'Projection J7',
                content: h(ProjectionTable, { days: 7 }),
            },
            projectionD30: {
                title: 'Projection J30',
                content: h(ProjectionTable, { days: 30 }),
            },
        }"
    />
</template>
